import {
  MarqBrandEnumsWebsiteBrandSortedColumnEnum,
  MarqCommonEnumsCommentCommentUserTypeEnum,
  MarqCommonEnumsScannedStatusEnum,
  MarqCommonEnumsSortedOrderEnum,
  MarqCommonEnumsSwWebsiteDelistingProgressEnum,
  MarqCommonEnumsSwWebsiteReportProgressEnum,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteListRequest,
} from '~/swagger/data-contracts';

export const enum DomainNamesTabGroupEnum {
  Scanned = 'scanned',
  Flagged = 'flagged',
  InProgress = 'in-progress',
  CaseClosed = 'case-closed',
  Watchlist = 'watchlist',
}

export type FilterQueryParams = Omit<
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteListRequest,
  'tab' | 'limit' | 'scanned_date' | 'requested_date' | 'added_date'
> & {
  scanned_date_start?: string | null;
  scanned_date_end?: string | null;
  scanned_status_filter?: MarqCommonEnumsScannedStatusEnum;
  requested_date_start?: string | null;
  requested_date_end?: string | null;
  added_date_start?: string | null;
  added_date_end?: string | null;
  comment_user_type_filter?: MarqCommonEnumsCommentCommentUserTypeEnum[];
};

export const enum DomainNamesColumnEnum {
  Domain = 'domain',
  Screenshot = 'screenshot',
  IpAddress = 'ip_address',
  Title = 'title',
  Country = 'country',
  Tld = 'tld',
  Tag = 'tag',
  Comment = 'comment',
  FirstScanned = 'first_scanned',
  MetaDescription = 'meta_description',
  Registrant = 'registrant',
  Registrar = 'registrar',
  HostingProvider = 'hosting_provider',
  MxRecords = 'mx_records',
  SslCertificate = 'ssl_certificate',
  LogoDetected = 'logo_detected',
  RegistrationDate = 'registration_date',
  ExpirationDate = 'expiration_date',
  Actions = 'actions',
}

export type DynamicDomainNamesColumn = Exclude<DomainNamesColumnEnum, DomainNamesColumnEnum.Actions>;

export type ReportStatus =
  | MarqCommonEnumsSwWebsiteDelistingProgressEnum
  | MarqCommonEnumsSwWebsiteReportProgressEnum
  | 'requested';

// SortedColumnEnum 중에서 실제로 사용하는 것들만 추려냄
type SortColumn = Extract<
  MarqBrandEnumsWebsiteBrandSortedColumnEnum,
  'scanned_date' | 'request_date' | 'domain_name' | 'updated_date' | 'watchlist_added_date' | 'comment_date'
>;
export type SortValue = `${SortColumn}+${MarqCommonEnumsSortedOrderEnum}`;

export type ViewMode = 'table' | 'grid';
